.editIndustry {
    width: 100%;
    * #typeahead-industry-edit {
        transform: translateX(100%);
    }
}
